export function formatErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error.trim() || "Unexpected error";
  }
  if (error && typeof error === "object") {
    if (
      "message" in error &&
      typeof error.message === "string" &&
      error.message.trim().length > 0
    ) {
      return error.message;
    }
    if (
      "error" in error &&
      typeof error.error === "string" &&
      error.error.trim().length > 0
    ) {
      return error.error;
    }
  }
  try {
    return JSON.stringify(error);
  } catch {
    return "Unexpected error";
  }
}
